










import Vue from 'vue';

export default Vue.extend({
  name: 'v-image',
  props: {
    src: String,
    width: Number,
    height: Number,
    hover: {
      type: Boolean,
      default: true,
    },
  },
});
